
import React from 'react';

const WithdrawalPayment = ({ rowData }) => {
    return (
        <span>
            {Number.isNaN(Number(rowData.amount))
            ? `${Math.abs(rowData.amount)}`
            : `${Number(Math.abs(rowData.amount)).toLocaleString()}`}<br/>
        </span>
    );
}

export default WithdrawalPayment;